export default __webpack_public_path__ + "static/media/semi.c9b34970.png";